import { AggregationMethod } from "building-types/dataSequences/measures";
import type { BuiltInDataTableSettings } from "building-types/dataSequences/scheduleSettingsTable";

export const WINDOWS_SCHEDULE_DEFAULT_SETTINGS: BuiltInDataTableSettings = {
  type: "WINDOW",
  scheduleName: "WINDOWS",
  attributes: {
    tag: {
      definesEntity: true,
      unit: undefined,
      index: 0,
      isHidden: false,
      displayName: "Label",
      includeFilter: "",
      excludeFilter: "",
    },
    width: {
      definesEntity: true,
      unit: "INCHES",
      index: 2,
      isHidden: false,
      displayName: "Width",
      includeFilter: "",
      excludeFilter: "",
    },
    height: {
      definesEntity: true,
      unit: "INCHES",
      index: 3,
      isHidden: false,
      displayName: "Height",
      includeFilter: "",
      excludeFilter: "",
    },
    perimeter: {
      definesEntity: false,
      unit: "INCHES",
      index: 0,
      isHidden: true,
      displayName: "Perimeter",
      includeFilter: "",
      excludeFilter: "",
    },
    operationType: {
      definesEntity: false,
      unit: undefined,
      index: 0,
      isHidden: true,
      displayName: "Operation Type",
      includeFilter: "",
      excludeFilter: "",
    },
    verticalDivisions: {
      definesEntity: false,
      unit: undefined,
      index: 0,
      isHidden: true,
      displayName: "Vertical Divisions",
      includeFilter: "",
      excludeFilter: "",
    },
    panelType: {
      definesEntity: false,
      unit: undefined,
      index: 0,
      isHidden: true,
      displayName: "Panel Type",
      includeFilter: "",
      excludeFilter: "",
    },
    glazingType: {
      definesEntity: false,
      unit: undefined,
      index: 0,
      isHidden: true,
      displayName: "Glazing Type",
      includeFilter: "",
      excludeFilter: "",
    },
    glazingColor: {
      definesEntity: false,
      unit: undefined,
      index: 0,
      isHidden: true,
      displayName: "Glazing Color",
      includeFilter: "",
      excludeFilter: "",
    },
    grids: {
      definesEntity: false,
      unit: undefined,
      index: 0,
      isHidden: true,
      displayName: "Grids",
      includeFilter: "",
      excludeFilter: "",
    },
    floor: {
      definesEntity: false,
      unit: undefined,
      index: 0,
      isHidden: true,
      displayName: "Floor",
      includeFilter: "",
      excludeFilter: "",
    },
  },
  measures: {
    count: {
      isAggregated: true,
      unit: "QUANTITY",
      index: 1,
      isHidden: false,
      displayName: "Count",
      aggregationMethod: AggregationMethod.SUM,
    },
    width: {
      isAggregated: false,
      unit: "INCHES",
      index: 0,
      isHidden: true,
      displayName: "Total Width",
      aggregationMethod: AggregationMethod.SUM,
    },
    height: {
      isAggregated: false,
      unit: "INCHES",
      index: 0,
      isHidden: true,
      displayName: "Total Height",
      aggregationMethod: AggregationMethod.SUM,
    },
    perimeter: {
      isAggregated: false,
      unit: "INCHES",
      index: 0,
      isHidden: true,
      displayName: "Total Perimeter",
      aggregationMethod: AggregationMethod.SUM,
    },
  },
  footnote: "",
  forceColumnNameUppercase: true,
  isActive: true,
};

export const DOORS_SCHEDULE_DEFAULT_SETTINGS: BuiltInDataTableSettings = {
  type: "DOOR",
  scheduleName: "DOORS",
  attributes: {
    tag: {
      definesEntity: true,
      unit: undefined,
      index: 0,
      isHidden: false,
      displayName: "Label",
      includeFilter: "",
      excludeFilter: "",
    },
    width: {
      definesEntity: true,
      unit: "INCHES",
      index: 2,
      isHidden: false,
      displayName: "Width",
      includeFilter: "",
      excludeFilter: "",
    },
    height: {
      definesEntity: true,
      unit: "INCHES",
      index: 3,
      isHidden: false,
      displayName: "Height",
      includeFilter: "",
      excludeFilter: "",
    },
    handing: {
      definesEntity: true,
      unit: undefined,
      index: 4,
      isHidden: false,
      displayName: "Handing",
      includeFilter: "",
      excludeFilter: "",
    },
    area: {
      definesEntity: false,
      unit: "SQ IN",
      index: 0,
      isHidden: true,
      displayName: "Area",
      includeFilter: "",
      excludeFilter: "",
    },
    class: {
      definesEntity: false,
      unit: undefined,
      index: 0,
      isHidden: true,
      displayName: "Class",
      includeFilter: "",
      excludeFilter: "",
    },
    panels: {
      definesEntity: false,
      unit: undefined,
      index: 0,
      isHidden: true,
      displayName: "Panels",
      includeFilter: "",
      excludeFilter: "",
    },
    swing: {
      definesEntity: false,
      unit: undefined,
      index: 0,
      isHidden: true,
      displayName: "Swing",
      includeFilter: "",
      excludeFilter: "",
    },
    details: {
      definesEntity: false,
      unit: undefined,
      index: 0,
      isHidden: true,
      displayName: "Details",
      includeFilter: "",
      excludeFilter: "",
    },
    floor: {
      definesEntity: false,
      unit: undefined,
      index: 0,
      isHidden: true,
      displayName: "Floor",
      includeFilter: "",
      excludeFilter: "",
    },
  },
  measures: {
    count: {
      isAggregated: true,
      unit: "QUANTITY",
      index: 1,
      isHidden: false,
      displayName: "Count",
      aggregationMethod: AggregationMethod.SUM,
    },
    width: {
      isAggregated: false,
      unit: "INCHES",
      index: 0,
      isHidden: true,
      displayName: "Total Width",
      aggregationMethod: AggregationMethod.SUM,
    },
    height: {
      isAggregated: false,
      unit: "INCHES",
      index: 0,
      isHidden: true,
      displayName: "Total Height",
      aggregationMethod: AggregationMethod.SUM,
    },
    area: {
      isAggregated: false,
      unit: "SQ IN",
      index: 0,
      isHidden: true,
      displayName: "Total Area",
      aggregationMethod: AggregationMethod.SUM,
    },
  },
  footnote: "",
  forceColumnNameUppercase: true,
  isActive: true,
};

export const CASEWORK_SCHEDULE_DEFAULT_SETTINGS: BuiltInDataTableSettings = {
  type: "CASEWORK",
  scheduleName: "CASEWORK",
  attributes: {
    roomName: {
      definesEntity: true,
      unit: undefined,
      index: 0,
      isHidden: false,
      displayName: "Name",
      includeFilter: "",
      excludeFilter: "",
    },
    material: {
      definesEntity: true,
      unit: undefined,
      index: 2,
      isHidden: false,
      displayName: "Floor Material",
      includeFilter: "",
      excludeFilter: "",
    },
    level: {
      definesEntity: true,
      unit: undefined,
      index: 3,
      isHidden: false,
      displayName: "Level",
      includeFilter: "",
      excludeFilter: "",
    },
    materialHash: {
      definesEntity: false,
      unit: undefined,
      index: 0,
      isHidden: true,
      displayName: "Material Hash",
      includeFilter: "",
      excludeFilter: "",
    },
    tag: {
      definesEntity: false,
      unit: undefined,
      index: 0,
      isHidden: false,
      displayName: "Tag",
      includeFilter: "",
      excludeFilter: "",
    },
  },
  measures: {
    area: {
      isAggregated: true,
      unit: "SQ FT",
      index: 1,
      isHidden: false,
      displayName: "Area",
      aggregationMethod: AggregationMethod.SUM,
    },
    count: {
      isAggregated: false,
      unit: "QUANTITY",
      index: 0,
      isHidden: true,
      displayName: "Count",
      aggregationMethod: AggregationMethod.SUM,
    },
  },
  footnote: "",
  forceColumnNameUppercase: true,
  isActive: false,
};

export const ROOMS_SCHEDULE_DEFAULT_SETTINGS: BuiltInDataTableSettings = {
  type: "FLOORING",
  scheduleName: "ROOMS NET AREA",
  attributes: {
    roomName: {
      definesEntity: true,
      unit: undefined,
      index: 0,
      isHidden: false,
      displayName: "Name",
      includeFilter: "",
      excludeFilter: "",
    },
    material: {
      definesEntity: true,
      unit: undefined,
      index: 2,
      isHidden: false,
      displayName: "Floor Material",
      includeFilter: "",
      excludeFilter: "",
    },
    level: {
      definesEntity: true,
      unit: undefined,
      index: 3,
      isHidden: false,
      displayName: "Level",
      includeFilter: "",
      excludeFilter: "",
    },
    materialHash: {
      definesEntity: false,
      unit: undefined,
      index: 0,
      isHidden: true,
      displayName: "Material Hash",
      includeFilter: "",
      excludeFilter: "",
    },
  },
  measures: {
    area: {
      isAggregated: true,
      unit: "SQ FT",
      index: 1,
      isHidden: false,
      displayName: "Area",
      aggregationMethod: AggregationMethod.SUM,
    },
    count: {
      isAggregated: false,
      unit: "QUANTITY",
      index: 0,
      isHidden: true,
      displayName: "Count",
      aggregationMethod: AggregationMethod.SUM,
    },
  },
  footnote: "",
  forceColumnNameUppercase: true,
  isActive: true,
};
